import cn from 'classnames'
import { motion } from 'framer-motion'
import { FC, useMemo, useRef } from 'react'

import { DustedText } from '@shared'
import { AnswerData } from '@store'

import styles from '../Dialog.module.scss'

type Props = {
  answer: AnswerData
  isSelected: boolean
  isLast: boolean
  hidden: boolean
  selectedAnswerId: string | null
  onClick: (answer: AnswerData) => void
}

export const AnswerItem: FC<Props> = ({
  answer,
  isSelected,
  isLast,
  hidden,
  selectedAnswerId,
  onClick,
}) => {

  const elementRef = useRef<HTMLDivElement>(null)

  const yOffset = useMemo(() => {
    if (!isSelected || !elementRef.current) return 0
    const element = elementRef.current
    const parent = element.parentElement
    if (!parent) return 0

    const parentRect = parent.getBoundingClientRect()
    const elementRect = element.getBoundingClientRect()
    return elementRect.top - parentRect.top
  }, [isSelected])

  return (
    <motion.div
      ref={elementRef}
      layout
      animate={{
        borderBottom:
          !isLast && !selectedAnswerId
            ? '2px dotted var(--palette-gray-400)'
            : '2px dotted transparent',
        y: -yOffset,
      }}
      transition={{
        duration: 0.4,
        easings: 'easeInOut',
      }}
      className={styles.answer}
    >
      <motion.div
        className={styles.answerText}
        onClick={() => onClick(answer)}
        animate={{
          color: isSelected
            ? 'var(--palette-gray-100)'
            : 'var(--palette-gray-300)',
        }}
        transition={{ duration: 0.3, delay: 0.2 }}
      >
        <DustedText
          text={answer.text}
          hidden={hidden}
          hasInitAnimation={false}
          className={cn({
            [styles.playerMessage]: isSelected,
          })}
        />
      </motion.div>
    </motion.div>
  )
}
